import type { NavigateFunction } from 'react-router';

// react-router の useNavigate を React ツリー外（saga など）から呼ぶための singleton。
// connected-react-router の push() を置き換える。
let navigator: NavigateFunction | null = null;

export const setNavigator = (nav: NavigateFunction) => {
  navigator = nav;
};

export const navigate = (to: string) => {
  if (navigator) {
    navigator(to);
  } else {
    // Router がマウントされる前に呼ばれた場合のフォールバック
    window.location.assign(to);
  }
};

// connected-react-router の state.router.location.search の置き換え（先頭の ? を除去）
export const getLocationSearch = () => window.location.search.replace(/^\?/, '');
